import "@fortius/primefaces-themes";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import React from "react";
import { Helmet } from "react-helmet";
import { DefaultTheme, ThemeProvider } from "styled-components";
import { OFA_THEME, OfaGlobalStyles } from "@fortius/prime-ui";
import { MsGlobalStyles } from "./msGlobalStyles";

interface IProps {
  theme?: DefaultTheme;
  children: React.ReactNode;
}

export const OfaThemeProvider: React.FC<IProps> = ({ theme = OFA_THEME, children }) => (
  <ThemeProvider theme={theme}>
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      {/* @ts-ignore */}
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap"
      />
    </Helmet>
    <OfaGlobalStyles />
    <MsGlobalStyles />
    {children}
  </ThemeProvider>
);
